export default [{
	path: 'analysis',
	component: () => import('../../sys/analysis/index'),
	redirect: '/sys/analysis/userLoginLog',
	children: [
		//登录信息统计
		{
			path: 'userLoginLog',
			component: () => import('../../sys/analysis/userLoginLog')
		},
		//课程统计总览
		{
			path: 'boardHome',
			component: () => import('../../sys/analysis/board/index.vue')
		},
		// 单项数据统计
		{
			path: 'singleItemStats',
			component: () => import('../../sys/analysis/singleItemStats')
		},
		// 模型调用统计
		{
			path: 'model-call',
			component: () => import('../../sys/analysis/model-call-statistics')
		},
		//用户访问信息统计
		{
			path: 'userLoginLog_Analysis',
			component: () => import('../../sys/analysis/userLoginLogAnalysis')
		}
	]
}]